export default "__VITE_ASSET__C7WB3QfM__"